module.exports = __webpack_public_path__ + "slide-01.png?f3daac85ee2a0ef57d3bb994e3a7a124";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide-01.png
// module id = 393
// module chunks = 0